import React from "react"
import styles from "./futurejoinus.css"

const FutureJoinus = (props) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" href="https://event.on24.com/wcc/r/2396249/85498380B371C9C251CD72F8AD02127D" target="_blank">REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default FutureJoinus